import React from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { getDateRangeForPreset } from "src/util/util.dateRange";
import "../../util/utils.defaultValues";
import { IFinalTableContextValue } from "../FinalTable/FinalTable";
import FinalTableSpy from "../FinalTable/FinalTableSpy";
import Icon, { IconName } from "../Icon/Icon";
import "./StatusFilter.scss";

export interface IStatusFilterProps {
  statusList: any[];
  useIsDeletedFilter?: boolean;
  selectedIndex?: number;
  fieldName?: string;
  fieldLabel?: string;
}

export interface IStatusFilterState {
  isOpen: boolean;
  selectedIndex: number;
  fieldName: string;
  fieldLabel: string;
}

export default class StatusFilter extends React.Component<IStatusFilterProps, IStatusFilterState> {
  constructor(props) {
    super(props);
    const { fieldLabel, fieldName, selectedIndex } = this.props;
    this.state = {
      isOpen: false,
      fieldLabel: fieldLabel ?? "Status",
      fieldName: fieldName ?? "statusID",
      selectedIndex: selectedIndex ?? -1,
    };
  }

  toggle = () => this.setState(s => ({ isOpen: !s.isOpen }));

  handleClick = (props: IFinalTableContextValue<{}>, selectedItem: any, index: number) => {
    this.setState({ selectedIndex: index });

    const value = selectedItem.value === -1 ? undefined : selectedItem.value;

    if (this.state.fieldName === "dateRangePreset") {
      const { updatedFromDate, updatedToDate } = getDateRangeForPreset(value);

      props.update({
        page: 1,
        query: {
          ...props.query,
          updatedFromDate,
          updatedToDate,
        },
      });
      return;
    }

    // Check whether to filter using `isDeleted` or `statusID`
    if (this.props.useIsDeletedFilter) {
      const isDeleted = value === 0;
      props.update({ page: 1, query: { ...props.query, isDeleted: String(isDeleted) } });
    } else {
      // Default case where we use `statusID`
      props.update({ page: 1, query: { ...props.query, [this.state.fieldName]: value } });
    }
  };

  caretLabel = (props: IFinalTableContextValue<{}>) => {
    const idx = this.state.selectedIndex;
    const value = props.query[this.state.fieldName];
    if (value) {
      return this.props.statusList.find(item => item.value === value)?.key;
    }
    return this.state.fieldLabel;
  };

  render() {
    const { statusList } = this.props;

    return (
      <FinalTableSpy>
        {props => (
          <div className="status-filter-v2">
            <Dropdown className="status-filter-v2__dropdown" isOpen={this.state.isOpen} toggle={this.toggle}>
              <DropdownToggle className="custom-dropdown-toggle">
                <span className="custom-dropdown-label">{this.caretLabel(props)}</span>
                <Icon name={IconName.ChevronDown} size="16px" />
              </DropdownToggle>
              <DropdownMenu>
                {statusList && statusList.length > 0 ? (
                  statusList.map((status, idx) => (
                    <DropdownItem key={`${status.value}-${idx}`} onClick={() => this.handleClick(props, status, idx)}>
                      {status.key}
                    </DropdownItem>
                  ))
                ) : (
                  <DropdownItem disabled>No statuses available</DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
      </FinalTableSpy>
    );
  }
}
